<template>
     <LayoutPage>
        <template v-slot:banner>
            <BannerSmallerWithSearchAndButton
                :imageName="$t('UI.banners.smallerBannerImage')"
                :description="$t('actualLandPlansPage.description')"
                :title="$t('actualLandPlansPage.title')"
            />
        </template>
        <template v-slot:content>
             <div class="mm-section box box--space-vertical">
                <div class="mm-section-content">
                    <div class="container-fluid w-100">

                        <div class="box box--space-vertical">
                            <router-link :to="localeRoute('news_landplan')"
                                class="mm-link mm-link--icon-left-space-s">
                                <i class="icon icon-arrow-left"></i>{{$t('actualLandPlansPage.backButton')}}
                            </router-link>
                        </div>

                        <div v-if="regionLinksRequestState === 'success'">
                            <div class="box box--space-top" >
                                <div class="row box--space-bottom">
                                    <div class="col-md-8">
                                        <h2 class="headline headline--fourth headline--colored pt-4">
                                            {{$t('actualLandPlansPage.headingA')}}
                                        </h2>
                                    </div>
                                    <div class="col-md-4">

                                        <SearchBox
                                            formClass='searchbox '
                                            inputClass='searchbox__text'
                                            iconClass='searchbox__icon searchbox__icon--margin-left'
                                            resultsClass="searchbox__results searchbox__results--banner2 searchbox__results--simple"
                                            outerWrapperClassname='searchbox--simple'
                                            :placeholderText="$t('actualLandPlansPage.searchBox.placeholder')"
                                            :apiSearchOperation="searchPlan"
                                            :onSelectItem="onSelectItem"
                                            :transform="res => res.map(item => {
                                                item.text = item.name;
                                                return item;
                                            })"
                                        />
                                    </div>
                                </div>
                                <div class="box box--bordered-top">

                                    <div class="box-header box-header--collapsible-md box-header--secondary box-header--white box-header--bordered-bottom ">
                                        <div class="box-header__main-content"
                                            :class="{'box-header__menu--collapse': isMobileOpened}">

                                            <div class="box-header__heading box-header__menu-active"
                                                @click="isMobileOpened = !isMobileOpened">
                                                {{actualRegionName ?
                                                    `${$t('actualLandPlansPage.navigation.activeText')}: ${actualRegionName}` :
                                                    $t('actualLandPlansPage.navigation.empty')}}
                                            </div>

                                            <ul class="box-header__menu  box-header__menu--light"
                                                :class="{
                                                    'box-header__menu-active': isMobileOpened
                                                }">
                                                <li v-for="item in regionLinks"
                                                    :key="item.id"
                                                    class="box-header__menu-item">
                                                    <router-link
                                                        active-class="active"
                                                        :to="localeRoute({
                                                            name: 'news_actual_landplans_region',
                                                            params: { region: item.url}
                                                        })"
                                                        style=""
                                                        class="box-header__menu-link">
                                                        {{item.name}}
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="box-header__right-content">
                                            <div @click="isMobileOpened = !isMobileOpened"
                                                :title="$t('actualLandPlansPage.navigation.buttonTitle')"
                                                class="box-header__icon box-header__icon--collapsible icon-right-menu">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                id="plans-list"
                                class="box box--border-bottom box--space-inside box--bordered-top box--bordered--strong box--rounded-bottom-8">
                                <div v-if="regionId">
                                    <router-link
                                        :to="localeRoute({name: 'news_actual_landplans'})"
                                        class="float-right text-link">
                                        <span class="icon icon-2x icon-close"></span>
                                    </router-link>
                                    <app-spinner
                                        v-if="districtLinksRequestState === 'request' ||
                                            cityLinksRequestState === 'request'" />
                                    <div
                                        v-else-if="districtLinksRequestState === 'failure' ||
                                            cityLinksRequestState === 'failure'">
                                        <div class="box box--spaces">
                                            <Error404 />
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div v-if="districtLinks && !districtId">
                                            <h2 class="headline headline--fifth headline--colored">
                                                {{$t('actualLandPlansPage.headingB')}}: {{actualRegionName}}
                                            </h2>
                                            <ul class="row text--bigger-paragraph icon-simple-list">
                                                <li
                                                    class="col-lg-3 col-md-4 col-sm-6 text--bigger-paragraph"
                                                    v-for="item in districtLinks"
                                                    :key="item.id">
                                                    <router-link
                                                        :to="localeRoute({
                                                            name: 'news_actual_landplans_region_district',
                                                            params: { region: regionId, district: item.url}
                                                        })"
                                                        class="text-link">
                                                        <span class="icon-simple-list__icon">
                                                            <i class="icon icon-tool"></i>
                                                        </span>
                                                        <span class="icon-simple-list__content">
                                                            {{item.name}}
                                                        </span>
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </div>
                                        <div v-if="districtId" class="">
                                            <div v-if="cityLinks">
                                                <p>
                                                    <router-link
                                                        :to="localeRoute({name: 'news_actual_landplans_region', params: { region: regionId}})"
                                                        class="mm-link mm-link--icon-left-space-s pb-4">
                                                        <i class="button__icon icon icon-arrow-left"></i>
                                                        {{$tc(`actualLandPlansPage.backToRegion`, actualRegionName)}}
                                                    </router-link>
                                                </p>

                                                <h2 class="headline headline--fifth headline--colored mt-2">
                                                    {{$t('actualLandPlansPage.headingC')}}: {{actualDistrictName}}
                                                </h2>
                                                <ul class="row text--bigger-paragraph icon-simple-list">
                                                    <li
                                                        class="col-lg-3 col-md-4 col-sm-6 "
                                                        v-for="item in cityLinks"
                                                        :key="item.id">
                                                        <router-link
                                                            v-if="item.municipalityId && item.municipalityId !== ''"
                                                            :to="localeRoute({name: 'news_actual_landplans_region_district_city', params: { region: regionId, district: districtId, city: item.url}})"
                                                            class="text-link">
                                                            <span class="icon-simple-list__icon">
                                                                <i class="icon"
                                                                    :class="{ 'icon-check text--colored': item.hasPlan === 1 }"></i>
                                                            </span>
                                                            <span class="icon-simple-list__content">{{item.name}}</span>
                                                        </router-link>
                                                        <span v-else
                                                            class="text--grey">
                                                            <span class="icon-simple-list__icon">
                                                                 <i class="icon"
                                                                    :class="{ 'icon-check text--colored': item.hasPlan === 1 }"></i>
                                                            </span>
                                                            <span class="icon-simple-list__content">{{item.name}}</span>
                                                        </span>

                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <span class="text--bigger-paragraph text--grey">
                                        {{$t('actualLandPlansPage.chooseRegionMessage')}}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div v-else>
                            <app-spinner v-if="regionLinksRequestState !== 'failure'"/>
                            <div v-else>
                                <div class="box box--spaces">
                                    <Error404 />
                                </div>
                            </div>
                        </div>

                        <div v-if="regionLinksRequestState === 'success'"
                            class="mm-section__row">
                            <div class="mm-section__faq-help">
                                <img v-if="$t('actualLandPlansPage.image')"
                                    :src="$t('actualLandPlansPage.image')"
                                    style="width: 100%" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </template>
     </LayoutPage>

</template>

<script>

import LayoutPage from '@/components/layouts/Page';
import { getRegions, searchPlan } from '@/services/MapsfyApi';
import BannerSmallerWithSearchAndButton from '@/components/ui/Banner/SmallerWithSearchAndButton';
import Error404 from '@/components/ui/Error/Error404';
import SearchBox from '@/components/searchApi';

export default {
    components: {
        LayoutPage,
        BannerSmallerWithSearchAndButton,
        Error404,
        SearchBox
    },
    watch: {
        '$route.params': function (r) {
            //console.log('RELOAD:', r);
            if (r.region && r.district) {
                this.getCityLinks(r.region, r.district);
                this.isMobileOpened = false;
            } else if (r.region) {
                this.getDistrictLinks(r.region);
                this.isMobileOpened = false;
            }
        }
    },
    created() {
        this.getRegionLinks();
        if (this.regionId && this.districtId) {
            this.getCityLinks(this.regionId, this.districtId);
        }
        if (this.regionId) {
            this.getDistrictLinks(this.regionId);
        }
    },
    computed: {
        regionId() {
            return this.$route.params.region;
        },
        districtId() {
            return this.$route.params.district;
        },
        actualRegionName() {
            if (this.regionId && this.regionLinks && this.regionLinks.length > 0) {
                const activeRegion = this.regionLinks.find(item => item.url === this.regionId);
                if (activeRegion && activeRegion.name) {
                    return activeRegion.name;
                }
            }
            return null;
        },
        actualDistrictName() {
            if (this.districtId && this.districtLinks && this.districtLinks.length > 0) {
                const activeRegion = this.districtLinks.find(item => item.url === this.districtId);
                if (activeRegion && activeRegion.name) {
                    return activeRegion.name;
                }
            }
            return null;
        }
    },
    data() {
        //console.log('process.env.BASE_URL: ', process.env.BASE_URL);
        return {
            regionLinks: [],
            districtLinks: [],
            cityLinks: [],
            regionLinksRequestState: null,
            districtLinksRequestState: null,
            cityLinksRequestState: null,
            isMobileOpened: false,
            publicPath: process.env.BASE_URL
        }
    },
    methods: {
        searchPlan(value) {
            return searchPlan(value);
        },
        onSelectItem(item) {
            const urlParts = item.fullUrl && item.fullUrl.split('/');
            if (urlParts.length === 3) {
                return this.$router.push(this.localeRoute({
                    name: 'news_actual_landplans_region_district_city',
                    params: {
                        region: urlParts[0],
                        district: urlParts[1],
                        city: urlParts[2]
                    }
                }));
            }
            console.error('Error in opening city: ', item);
        },
        getRegionLinks() {
            this.regionLinksRequestState = 'request';
            this.cityLinksRequestState = null;
            this.districtLinksRequestState = null;

            getRegions()
                .then(res => {
                    this.regionLinks = res;
                    this.regionLinksRequestState = "success";
                })
                .fail(() => {
                    this.regionLinksRequestState = "failure";
                });
        },
        getDistrictLinks(regionId) {
            this.districtLinks = [];
            this.cityLinksRequestState = null;
            this.districtLinksRequestState = 'request';
            getRegions(regionId)
                .then(res => {
                    this.districtLinks = res;
                    this.districtLinksRequestState = "success";
                })
                .fail(() => {
                    this.districtLinksRequestState = "failure";
                });
        },
        getCityLinks(regionId, districtId) {
            this.cityLinks = [];
            this.cityLinksRequestState = 'request';
            getRegions(`${regionId}/${districtId}`)
                .then(res => {
                    this.cityLinks = res;
                    this.cityLinksRequestState = "success";
                })
                .fail(() => {
                    this.cityLinksRequestState = "failure";
                });
        }
    }
}
</script>


<style lang="scss">
#plans-list {
    position: relative; top: -14px; box-shadow: 0 6px 5px 0px rgba(32, 44, 54, 0.13), 0 12px 10px 0px rgba(32, 44, 54, 0.13);
}

@media (max-width: 767px) {
    #plans-list {
        top: 0;
    }
}

$spaceLeft: 1.5rem;
.icon-simple-list {
    padding-inline-start: 30px;
    li {
        list-style: none;
        padding-right: ($spaceLeft * 1.5);
    }

    .icon-simple-list__icon {
        position: absolute;
        left: -$spaceLeft;
    }

    .icon-simple-list__content {
        margin-left: 0rem;
    }
}

.searchbox--simple {
    width: 100%;
    position: relative;
}

.searchbox {
    width: 100%;
}

.vue-page .searchbox__results.searchbox__results--simple {
    top: 6.2rem;
    left: 0rem;
    right: 0rem;
    -webkit-box-shadow: 0 0.8rem 2.4rem 0 rgba(0, 0, 0, 0.3);
    box-shadow: 0 0.8rem 2.4rem 0 rgba(0, 0, 0, 0.3);
    max-height: 30rem;
    border-radius: 0.4rem;
    border-top: 0;
    width: auto;
    z-index: 2100;
}
</style>
